import { ETableMenuItem, ETextMenuItem, FormMenuItem, PricingTableMenuItem } from '../types/enums';
import type { IFormatOption } from '../types/format-option';
import { EFormatTextType } from '../types/enums/format-text-type';

const defaultBold: IFormatOption = {
  type: EFormatTextType.Bold,
  title: 'bold',
  textStateItem: 'bold',
  icon: 'text-bold',
  externalId: 'menu-button-bold',
};

const defaultItalic: IFormatOption = {
  type: EFormatTextType.Italic,
  title: 'italic',
  textStateItem: 'italic',
  icon: 'text-italic',
  externalId: 'menu-button-italic',
};

const defaultUnderline: IFormatOption = {
  type: EFormatTextType.Underline,
  title: 'underline',
  textStateItem: 'underline',
  icon: 'text-underline',
  externalId: 'menu-button-underline',
};

const defaultStrike: IFormatOption = {
  type: EFormatTextType.Strikethrough,
  title: 'strikethrough',
  textStateItem: 'strike',
  icon: 'text-strike',
  externalId: 'menu-button-strike',
};

const defaultOrderedList: IFormatOption = {
  type: EFormatTextType.OrderedList,
  title: 'ordered-list',
  textStateItem: 'orderedList',
  icon: 'ordered-list',
  externalId: 'menu-button-ordered-list',
  disabled: 'listToggle',
};

const defaultUnorderedList: IFormatOption = {
  type: EFormatTextType.BulletList,
  title: 'bullet-list',
  textStateItem: 'bulletList',
  icon: 'unordered-list',
  externalId: 'menu-button-unordered-list',
  disabled: 'listToggle',
};

export const pricingTableTextFormatOptions: IFormatOption[] = [
  {
    ...defaultBold,
    callback: PricingTableMenuItem.ToggleBold,
  },
  {
    ...defaultItalic,
    callback: PricingTableMenuItem.ToggleItalic,
  },
  {
    ...defaultUnderline,
    callback: PricingTableMenuItem.ToggleUnderline,
  },
  {
    ...defaultStrike,
    callback: PricingTableMenuItem.ToggleStrike,
  },
  {
    ...defaultOrderedList,
    callback: PricingTableMenuItem.ToggleOrderedList,
  },
  {
    ...defaultUnorderedList,
    callback: PricingTableMenuItem.ToggleBulletList,
  },
];

export const tableTextFormatOptions: IFormatOption[] = [
  {
    ...defaultBold,
    hidden: 'xs',
    callback: ETableMenuItem.ToggleBold,
  },
  {
    ...defaultItalic,
    hidden: 'sm',

    callback: ETableMenuItem.ToggleItalic,
  },
  {
    ...defaultUnderline,
    hidden: 'sm',
    callback: ETableMenuItem.ToggleUnderline,
  },
  {
    ...defaultStrike,
    hidden: 'sm',
    callback: ETableMenuItem.ToggleStrike,
  },
  {
    ...defaultOrderedList,
    hidden: 'md',
    callback: ETableMenuItem.ToggleOrderedList,
  },
  {
    ...defaultUnorderedList,
    hidden: 'md',
    callback: ETableMenuItem.ToggleBulletList,
  },
];

export const textFormatOptions: IFormatOption[] = [
  {
    ...defaultBold,
    callback: ETextMenuItem.ToggleBold,
  },
  {
    ...defaultItalic,
    hidden: 'xs',
    callback: ETextMenuItem.ToggleItalic,
  },
  {
    ...defaultUnderline,
    hidden: 'xs',
    callback: ETextMenuItem.ToggleUnderline,
  },
  {
    ...defaultStrike,
    hidden: 'xs',
    callback: ETextMenuItem.ToggleStrike,
  },
  {
    ...defaultOrderedList,
    hidden: 'sm',
    callback: ETextMenuItem.ToggleOrderedList,
  },
  {
    ...defaultUnorderedList,
    hidden: 'sm',
    callback: ETextMenuItem.ToggleBulletList,
  },
];

export const formTextFormatOptions: IFormatOption[] = [
  {
    ...defaultBold,
    callback: FormMenuItem.Bold,
  },
  {
    ...defaultItalic,
    callback: FormMenuItem.Italic,
  },
  {
    ...defaultUnderline,
    callback: FormMenuItem.Underline,
  },
];
